import { Controller } from "@hotwired/stimulus"

const EDGE_TOLERANCE = 1

export default class extends Controller {
  static targets = ["track", "card", "prevButton", "nextButton", "startFade", "endFade"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.update())
    this.resizeObserver.observe(this.trackTarget)
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  prev() {
    this.scrollByPage(-1)
  }

  next() {
    this.scrollByPage(1)
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget
    const atStart = scrollLeft <= EDGE_TOLERANCE
    const atEnd = scrollLeft + clientWidth >= scrollWidth - EDGE_TOLERANCE

    this.prevButtonTarget.hidden = atStart
    this.startFadeTarget.hidden = atStart
    this.nextButtonTarget.hidden = atEnd
    this.endFadeTarget.hidden = atEnd
  }

  scrollByPage(direction) {
    const [first, second] = this.cardTargets
    if (!second) return

    const cardStep = second.offsetLeft - first.offsetLeft
    const visibleWidth = this.trackTarget.parentElement.clientWidth
    const cardsPerPage = Math.max(1, Math.floor(visibleWidth / cardStep))
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    this.trackTarget.scrollBy({ left: direction * cardsPerPage * cardStep, behavior: reducedMotion ? "auto" : "smooth" })
  }
}
